<template>
    <div class="chat_reconnect-wrapper">
        <div class="chat_reconnect_background"></div>
        <div class="chat_reconnect--content">
            <spinner :show="true"/>
            <div>{{ $t('connecting') }} ...</div>
        </div>
    </div>
</template>

<script>
  import Spinner from './Spinner'
  export default {
    name: 'ReconnectPopup',
    components: { Spinner }
  }
</script>

<style lang="scss">
.chat_reconnect-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .chat_reconnect_background {
        background-color: rgba(0,0,0,.5);
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .chat_reconnect--content {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        font-weight: bold;
    }
}
</style>
